import { CESimpleAttributePermissionAttributesBase } from './ce-simple-attribute-permission-attributes-base'


export class CESimpleAttributePermissionAttributes extends CESimpleAttributePermissionAttributesBase {

}